import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { map } from 'rxjs/operators';
import { GlobalService } from './global.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./global.service";
import * as i3 from "ngx-cookie-service";
var ApprovalService = /** @class */ (function () {
    function ApprovalService(http, globalService, cookieService) {
        this.http = http;
        this.globalService = globalService;
        this.cookieService = cookieService;
    }
    ApprovalService.prototype.header = function () {
        return {
            headers: new HttpHeaders()
                .set('token', this.cookieService.get('_q'))
        };
    };
    ApprovalService.prototype.generateLink = function (params) {
        return this.http.post(this.globalService.apiVersionHost + '/approval/generate-link', params, this.header()).pipe(map(function (response) { return response; }));
    };
    ApprovalService.prototype.submitByLink = function (params) {
        return this.http.post(this.globalService.apiVersionHost + '/approval/submit-approval-by-link', params).pipe(map(function (response) { return response; }));
    };
    ApprovalService.prototype.submitByLogin = function (params) {
        return this.http.post(this.globalService.apiVersionHost + '/approval/submit-approval-by-login', params).pipe(map(function (response) { return response; }));
    };
    ApprovalService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ApprovalService_Factory() { return new ApprovalService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.GlobalService), i0.ɵɵinject(i3.CookieService)); }, token: ApprovalService, providedIn: "root" });
    return ApprovalService;
}());
export { ApprovalService };
